var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-dropdown',{attrs:{"trigger":['click'],"placement":"bottomLeft"}},[_c('div',{class:_vm.$style.dropdown},[_c('i',{staticClass:"fe fe-bell",class:_vm.$style.icon})]),_c('div',{attrs:{"slot":"overlay"},slot:"overlay"},[_c('div',{staticClass:"card cui__utils__shadow width-350"},[_c('div',{staticClass:"card-body pb-2"},[_c('list3')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }